import * as types from '../types'

export const selectUnitAction = ({ requestUnit }) => ({
    type: types.SELECTED_UNIT,
    payload: {
        requestUnit,
    },
})
